import React from 'react';
import { Popover } from 'antd';
import { NavLink } from '../NavLink';
import { partners } from '@/data/partners';
import PartnerRow from '../PartnerRow';

export interface MenuItem {
    label: string;
    href: string;
    external?: boolean;
}

interface MenuWrapperProps {
    title: string;
    items: MenuItem[];
}

export function MenuWrapper({ title, items }: MenuWrapperProps) {
    const [placement, setPlacement] = React.useState<'right' | 'bottom'>('right');

    React.useEffect(() => {
        const update = () => setPlacement(window.innerWidth < 768 ? 'bottom' : 'right');
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    return (
        <div className="flex flex-col gap-2">
            <h3 className="text-sm md:text-lg lg:text-xl font-semibold text-defaultBlue">
                {title}
            </h3>

            <ul className="flex flex-col gap-2">
                {items.map((item, index) => (
                    <li className="text-sm md:text-base" key={index}>
                        {item.label === 'Partner' ? (
                            <Popover
                                placement={placement}
                                getPopupContainer={() => document.body}
                                overlayStyle={{ zIndex: 2000 }}
                                content={
                                    <div className="w-[calc(100vw-32px)] max-w-[420px] max-h-[400px] overflow-y-auto">
                                        {partners.map((partner) => (
                                            <PartnerRow
                                                key={partner.name}
                                                partner={partner}
                                            />
                                        ))}
                                    </div>
                                }
                                trigger="click"
                            >
                                <button>Partner</button>
                            </Popover>
                        ) : item.external ? (
                            <button>{item.label}</button>
                        ) : (
                            <NavLink href={item.href} id="footerList">
                                {item.label}
                            </NavLink>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}